import { render, staticRenderFns } from "./adminPassword.vue?vue&type=template&id=8d93204e&scoped=true&"
import script from "./adminPassword.vue?vue&type=script&lang=js&"
export * from "./adminPassword.vue?vue&type=script&lang=js&"
import style0 from "./adminPassword.vue?vue&type=style&index=0&id=8d93204e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d93204e",
  null
  
)

export default component.exports